import Loader from "./../../Components/Loader/PageLoader";
import { useAuth } from "./../../hooks";
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

function RegisterForm6() {
  const navigate = useNavigate();
  const iframeRef = useRef(null);

  const { useSelfie } = useAuth();
  const { data: selfie, isLoading: selfieIsLoading } = useSelfie();

  // Function to explicitly request camera access
  const requestCameraAccess = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ video: true });
    } catch (error) {
      console.error("Camera access denied:", error);
    }
  };

  useEffect(() => {
    requestCameraAccess();
  }, []);

  const handleIframeLoad = (event) => {
    try {
      const iframe = iframeRef.current;
      if (!iframe) return;

      if (iframe?.contentWindow?.location?.href) {
        const iframeLocation = iframe.contentWindow.location.href;
        const url = new URL(iframeLocation);
        const relativePath = `${url.pathname}${url.search}${url.hash}`;
        navigate(relativePath, { replace: true });
      }
    } catch (error) {
      console.log("Unable to access iframe content due to same-origin policy");
    }
  };

  return (
    <>
      {selfieIsLoading ? (
        <div className="flex items-center justify-center h-full">
          <Loader className="h-20 w-20" />
        </div>
      ) : (
        <iframe
          ref={iframeRef}
          id="Selfie"
          title="VideoKyc"
          src={selfie?.data?.videoUrl}
          onLoad={handleIframeLoad}
          allow="camera; microphone"
          style={{
            //   position: "relative",
            //   top: 0,
            //   left: 0,
            width: "100%",
            height: "100%",
            border: "none",
            overflow: "hidden",
          }}
        />
      )}
    </>
  );
}

export default RegisterForm6;
